'use strict';

module.exports = require('./Autowhatever').default;


//////////////////
// WEBPACK FOOTER
// /home/readymade/apps/facelift_production/shared/~/react-autowhatever/dist/index.js
// module id = 324
// module chunks = 0 1